(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lab-bundle-billing-code', {
            parent: 'entity',
            url: '/lab-bundle-billing-code',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'LabBundleBillingCodes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-codes.html',
                    controller: 'LabBundleBillingCodeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('lab-bundle-billing-code-detail.edit', {
            parent: 'lab-bundle-billing-code-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-code-dialog.html',
                    controller: 'LabBundleBillingCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['LabBundleBillingCode', function(LabBundleBillingCode) {
                            return LabBundleBillingCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lab-bundle-billing-code.new', {
            parent: 'lab-bundle-billing-code',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-code-dialog.html',
                    controller: 'LabBundleBillingCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                testCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lab-bundle-billing-code', null, { reload: 'lab-bundle-billing-code' });
                }, function() {
                    $state.go('lab-bundle-billing-code');
                });
            }]
        })
        .state('lab-bundle-billing-code.edit', {
            parent: 'lab-bundle-billing-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-code-dialog.html',
                    controller: 'LabBundleBillingCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LabBundleBillingCode', function(LabBundleBillingCode) {
                            return LabBundleBillingCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lab-bundle-billing-code', null, { reload: 'lab-bundle-billing-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lab-bundle-billing-code.delete', {
            parent: 'lab-bundle-billing-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-code-delete-dialog.html',
                    controller: 'LabBundleBillingCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LabBundleBillingCode', function(LabBundleBillingCode) {
                            return LabBundleBillingCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lab-bundle-billing-code', null, { reload: 'lab-bundle-billing-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
